// Split out of MentionAutocomplete.tsx (react-refresh/only-export-components)
// — a plain factory function, not a component. Behavior unchanged.

/**
 * Creates a stable ref-holder function for MentionAutocomplete's keydown
 * handler, so a parent textarea can delegate Enter/Escape/Arrow key handling
 * to whichever MentionAutocomplete instance is currently mounted, e.g.:
 *
 *   const mentionKeyHandlerRef = useRef(createMentionKeyHandler());
 *   ...
 *   <MentionAutocomplete onKeyDown={mentionKeyHandlerRef.current} ... />
 *   <textarea onKeyDown={(e) => {
 *     if (mentionKeyHandlerRef.current(e)) e.preventDefault();
 *   }} />
 *
 * Returns a stable function object that delegates to whatever implementation
 * MentionAutocomplete last assigned to `_impl`.
 */
export function createMentionKeyHandler(): (e: React.KeyboardEvent) => boolean {
  const handler = (e: React.KeyboardEvent): boolean => {
    const impl = (handler as unknown as { _impl?: (e: React.KeyboardEvent) => boolean })._impl;
    return impl ? impl(e) : false;
  };
  return handler;
}
